import { useState, useEffect } from "react";

export function useCreateScriptTag(src) {
	const [status, setStatus] = useState(src ? "loading" : "idle");

	useEffect(() => {
		if (!src) {
			setStatus("idle");
			return;
		}

		// Check if script already exists
		let script = document.querySelector(`script[src="${src}"]`);

		if (!script) {
			// Create script element
			script = document.createElement("script");
			script.src = src;
			script.async = true;
			script.setAttribute("data-status", "loading");
			document.body.appendChild(script);

			// Set status when script loads or errors
			const setAttributeFromEvent = (event) => {
				script.setAttribute(
					"data-status",
					event.type === "load" ? "ready" : "error"
				);
			};

			script.addEventListener("load", setAttributeFromEvent);
			script.addEventListener("error", setAttributeFromEvent);
		} else {
			// Grab existing status
			setStatus(script.getAttribute("data-status"));
		}

		// Script status handler
		const setStateFromEvent = (event) => {
			setStatus(event.type === "load" ? "ready" : "error");
		};

		script.addEventListener("load", setStateFromEvent);
		script.addEventListener("error", setStateFromEvent);

		// Cleanup
		return () => {
			if (script) {
				script.removeEventListener("load", setStateFromEvent);
				script.removeEventListener("error", setStateFromEvent);
			}
		};
	}, [src]);

	return status;
}
